import styled from 'styled-components';
import { breakpoints, verticalGutter } from '../../styles';

/**
 * NOTE: Reused in SalesToolResults component as well
 */
export default styled.section`
  position: relative;
  min-height: 50vh;

  /* slick overwrite */
  .slick {
    &-slider {
      /* for shadow */
      margin-bottom: -0.5rem;
    }
    &-slide {
      /* for upsell badge */
      margin-top: 1.5rem;
    }
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    min-height: 0;
    height: calc(100% + ${verticalGutter}rem);
    padding-top: 0;
    padding-bottom: 0;

    .ui.card {
      height: 100%;
    }
  }

  @media only screen and (min-width: ${breakpoints.computer}) {
    .slick {
      &-slider {
        margin: -1.5rem ${verticalGutter / -2}rem 0;
        padding-right: ${verticalGutter / -2}rem;
      }
    }
  }
`;
